import { Component, Output, EventEmitter, OnInit, Input, SimpleChanges } from '@angular/core';
import { ArticleService } from '../article.service';
import { SchoolData } from 'src/app/models/schoolUser';
import { el } from '@fullcalendar/core/internal-common';

@Component({
  selector: 'app-article',
  standalone: true, // <-- Add this line
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss']
})
export class ArticleComponent implements OnInit {
  @Output() pageDataLoaded = new EventEmitter<any>();
  @Output() pageTeacherDataLoaded = new EventEmitter<any>();

  @Input() pageName: string = '';
  article: any;
  public schoolProps!: SchoolData;

  constructor(private articleService: ArticleService) { }

  ngOnInit() {
    this.schoolProps = JSON.parse(localStorage.getItem('userData') || '{}');
    if (this.schoolProps.properties.user_type !== 'Teacher') {
      this.loadPageData();
    } else {
      this.loadTeacherPageData();
    }
  }

  // ngOnChanges(changes: SimpleChanges) {
  //   if (changes['pageName'] && changes['pageName'].currentValue) {
  //     this.loadPageData();
  //   }
  // }
  loadPageData() {
    this.articleService.getPageData(this.pageName).subscribe({
      next: (res: any) => {
        this.pageDataLoaded.emit(res.data);
        if (res.status) {
          console.log("this.loadPageData", res);

          this.article = res.articles;
          console.log("this.loadPageData", this.article);
          // Handle successful data load if needed
        }
      }
    });
  }

  loadTeacherPageData() {
    this.articleService.getPageTeacherData(this.pageName).subscribe({
      next: (res: any) => {
        this.pageTeacherDataLoaded.emit(res.data);
        if (res.status) {
          this.article = res.articles;
          console.log("this.loadPageData", res);

          // Handle successful data load if needed
        }
      }
    });
  }
}